import * as React from 'react';

import { DisplayAd } from 'constants/ads';

import { MesoDisplayAd } from './meso-display-ad';
import { MesoTrigger } from './meso-trigger';

interface MesoSideRailProps {
  pageName: string;
}

export const MesoSideRail: React.FunctionComponent<MesoSideRailProps> = props => {
  const { pageName } = props;

  return (
    <>
      <MesoDisplayAd {...DisplayAd.SIDERAIL_R1} />
      <MesoDisplayAd {...DisplayAd.SIDERAIL_RM} />
      <MesoDisplayAd {...DisplayAd.SIDERAIL_R2} />
      <MesoTrigger pageName={pageName} />
    </>
  );
};
MesoSideRail.displayName = 'MesoSideRail';
